/* eslint-disable import/no-anonymous-default-export */
import coveragePage from "./coverage-page.json"
import parametersPage from "./parameters-page.json"
import prepackagesPage from "./prepackages-page.json"
import pricingPage from "./pricing-page.json"
import tribeQuotePage from "./tribe-quote-page.json"

export default {
  "tribe-quote-page": tribeQuotePage,
  "coverage-page": coveragePage,
  "parameters-page": parametersPage,
  "pricing-page": pricingPage,
  "prepackages-page": prepackagesPage,
}
